<template>
	<div class="flex-row fz-14">
		<div class="color-gy-8 mr-16 text-align-right pt-6" style="width:60px">{{ info.label }}</div>
		<el-form ref="form" :model="form" :rules="rules" @submit.native.prevent>
			<el-form-item prop="value">
				<el-checkbox-group v-model="form.value">
					<el-checkbox v-for="item in info.content.options" :key="item.value" :label="item.value">
						{{ item.label }}
					</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	props: {
		info: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			form: {
				value: this.info.content.select_value,
			},
			rules: {
				value: [
					{
						required: true,
						message: '请选择',
						trigger: 'change',
					},
				],
			},
		};
	},
	methods: {
		getValue() {
			return new Promise((res, rej) => {
				this.$refs['form'].validate(valid => {
					if (valid) {
						res(this.form.value);
					} else {
						rej();
					}
				});
			});
		},
	},
};
</script>

<style lang="less" scoped>
::v-deep .el-checkbox__label {
	padding-left: 8px;
	color: @color-gy9;
	font-weight: 400;
}
</style>
